import { render } from "./RbiCreate.vue?vue&type=template&id=1ab3ba89&scoped=true"
import script from "./RbiCreate.vue?vue&type=script&lang=js"
export * from "./RbiCreate.vue?vue&type=script&lang=js"

import "./RbiCreate.vue?vue&type=style&index=0&id=1ab3ba89&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ab3ba89"

export default script